module.exports = __webpack_public_path__ + "static/media/6wheels.37d082c2.svg";